import axios from "axios";

const baseURL = "https://server.startup.gov.ge/api/";

export const baseAPI = axios.create({
  baseURL,
});
